function load(component) {
    return () => import(`@/components/${component}.vue`);
}
export default {
    path: "account",
    component: load("account/layout"),
    children: [
        {
            path: "",
            name: "account",
            component: load("account/index"),
            meta: {
                parent: "account",
                child: "account",
                deal: false
            }
        },
        {
            path: "create",
            name: "account-create",
            component: load("account/create"),
            meta: {
                parent: "account",
                child: "account",
                deal: false
            }
        },
        {
            path: "details/:id",
            name: "account-details",
            component: load("account/details"),
            meta: {
                parent: "account",
                child: "account",
                deal: false
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/components/account/route/index.js